<script setup>
import { toRefs } from "vue";
import moment from "moment";
import InfoHolder from "@/components/global/drawer/InfoHolder.vue";

const props = defineProps({
  course: {
    type: Object,
  },
});

const { course } = toRefs(props);

const formatDate = (date) => {
  return moment(date, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm");
};
</script>

<template>
  <div v-if="Object.keys(course).length > 0" class="pa-5">
    <h1>{{ course.cycle }}</h1>
    <v-divider />
    <div class="d-flex box-holder">
      <div class="d-flex box-row flex-1-0-0">
        <div class="box-container mt-5">
          <h3 class="pa-2"><v-icon>mdi-school</v-icon> Course Data</h3>
          <InfoHolder title="Training Cycle" :info="course.cycle" />

          <InfoHolder
            title="Training Course"
            :info="course.courseSection?.name"
          />

          <InfoHolder title="Thematic Area" :info="course.thematicArea?.name" />

          <InfoHolder title="Type" :info="course.courseType?.name" />

          <InfoHolder
            title="Status"
            :info="course.status?.name ? course.status?.name : '-'"
          />

          <InfoHolder title="Odyssea Project" :info="course.project?.name" />

          <InfoHolder title="Odyssea Branch" :info="course.branch?.name" />

          <InfoHolder title="Start Date" :info="formatDate(course.startDate)" />

          <InfoHolder title="End Date" :info="formatDate(course.endDate)" />

          <InfoHolder title="Hours" :info="course.duration" />

          <InfoHolder
            title="Location"
            :info="course.location ? course.location : '-'"
          />

          <InfoHolder title="Tutor" :info="course.tutor ? course.tutor : '-'" />
        </div>
        <div class="d-flex" style="gap: 10px">
          <div class="box-container box-w3 mt-5">
            <h3 class="pa-2">
              <v-icon>mdi-account-school-outline</v-icon> Pre-Registered
              Beneficiaries
            </h3>

            <div
              v-for="preben in course.preregisteredBeneficiaries"
              :key="preben.id"
              class="pa-2"
            >
              <router-link
                :to="'/beneficiary/intake/view/' + preben.id"
                target="_blank"
                class="chip-link-color-academy"
              >
                <v-chip> {{ preben.name }} </v-chip>
              </router-link>
              <!-- <v-chip @click="handleBeneficiaryClick(preben.id, $event)">
                {{ preben.name }}
              </v-chip> -->
            </div>
          </div>

          <div class="box-container box-w3 mt-5">
            <h3 class="pa-2">
              <v-icon>mdi-account-school</v-icon> Registered Beneficiaries
            </h3>
            <div
              v-for="reben in course.registeredBeneficiaries"
              :key="reben.id"
              class="pa-2"
            >
              <router-link
                :to="'/beneficiary/intake/view/' + reben.id"
                target="_blank"
                class="chip-link-color-academy"
              >
                <v-chip> {{ reben.name }} </v-chip>
              </router-link>
              <!-- <v-chip @click="handleBeneficiaryClick(reben.id, $event)">
                {{ reben.name }}
              </v-chip> -->
            </div>
          </div>

          <div class="box-container box-w3 mt-5">
            <h3 class="pa-2">
              <v-icon>mdi-star</v-icon> Completed Beneficiaries
            </h3>

            <div
              v-for="coben in course.completedBeneficiaries"
              :key="coben.id"
              class="pa-2"
            >
              <router-link
                :to="'/beneficiary/intake/view/' + coben.id"
                target="_blank"
                class="chip-link-color-academy"
              >
                <v-chip> {{ coben.name }} </v-chip>
              </router-link>
              <!-- <v-chip @click="handleBeneficiaryClick(coben.id, $event)">
                {{ coben.name }}
              </v-chip> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 48px;
  color: rgb(var(--v-theme-academy));
}
.box-holder {
  gap: 20px;
  .box-row {
    flex-direction: column;
    .box-w3 {
      width: 100%;
    }
    .box-container {
      border: 1px solid rgb(var(--v-theme-academy));
      h3 {
        background-color: rgb(var(--v-theme-academy));
        color: white;
      }
      .info {
        .label {
          text-decoration: underline;
        }
        .answer {
          display: block;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
